module.exports = __webpack_public_path__ + "img/logo_check_motors_white.f859a038.png";